import { Dispatch, SetStateAction } from 'react';
import ConfigureShippingData from '@/components/Modals/ConfigureShippingData';
import ConfirmAddress from '@/components/Modals/ConfirmAddress';
import { EditCompanyDataModals } from '@/components/Modals/MyCompany/EditCompanyData';
import RegisterCompany from '@/components/Modals/RegisterCompany';
import { useUser } from '@/contexts/AuthContext';

interface IModalEditCompanyInfoProps {
  currentModal: EditCompanyDataModals;
  setCurrentModal: Dispatch<SetStateAction<EditCompanyDataModals>>;
  handleClose: () => void;
}

const ModalEditCompanyInfo = (props: IModalEditCompanyInfoProps) => {
  const { currentModal, setCurrentModal, handleClose } = props;
  const { defaultMembership } = useUser();

  const onSuccessRegisterCompany = () => {
    if (!defaultMembership?.company.has_confirmed_shipping) {
      setCurrentModal(EditCompanyDataModals.RESET_COMPANY_SHIPPING_DATA);
      return;
    }
    handleClose();
  };

  return (
    <>
      {
        {
          [EditCompanyDataModals.CLOSED]: <></>,
          [EditCompanyDataModals.RESET_COMPANY]: (
            <RegisterCompany
              isOpen={currentModal === EditCompanyDataModals.RESET_COMPANY}
              closeModal={handleClose}
              onSuccess={onSuccessRegisterCompany}
              isEditingCompany={
                !!defaultMembership?.company.has_confirmed_configuration
              }
            />
          ),
          [EditCompanyDataModals.RESET_COMPANY_ADDRESS]: (
            <ConfirmAddress
              isOpen={
                currentModal === EditCompanyDataModals.RESET_COMPANY_ADDRESS
              }
              closeModal={handleClose}
              onSuccess={handleClose}
              isEditingAddress={
                !!defaultMembership?.company.has_confirmed_address
              }
            />
          ),
          [EditCompanyDataModals.RESET_COMPANY_SHIPPING_DATA]: (
            <ConfigureShippingData
              isOpen={
                currentModal ===
                EditCompanyDataModals.RESET_COMPANY_SHIPPING_DATA
              }
              onSuccess={handleClose}
              handleClose={handleClose}
            />
          ),
        }[currentModal]
      }
    </>
  );
};

export default ModalEditCompanyInfo;
export type { IModalEditCompanyInfoProps };
